import { useSuspenseMaxDomainsQuery } from '#api/domains.queries.ts';
import { Spacer } from '#components/patterns/spacer/Spacer.tsx';
import { DomainTable } from './DomainTable.tsx';

type Props = {
  /** Admin and endpoint providers alike; a domain either one uses isn't listed */
  idps: Array<{ domainID: string | null }>;
  className?: string;
};

export function DomainList({ idps, className }: Props) {
  const {
    data: { data: domains },
  } = useSuspenseMaxDomainsQuery();

  const unusedDomains = domains.filter((d) => !idps.some((p) => p.domainID === d.id));

  if (!unusedDomains.length) return null;

  return (
    <section className={className}>
      <h2 className="h4">Domains</h2>
      <Spacer direction="vertical">
        <DomainTable data={unusedDomains} />
      </Spacer>
    </section>
  );
}
